// extracted by mini-css-extract-plugin
export default {"barrelCardMirror":"DK8l6s0N65GZPTa8yHPK"};